import Vue from "vue";
import Router from "vue-router";
import Global from "@/components/utils/Global";
import main from "@/components/page/main.vue";
import login from "@/components/page/login.vue";
import guide from "@/components/page/guide.vue";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // console.log('Router eorro', err);
  });
};

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/",
      name: "main",
      component: main,
      children: [
        {
          path: "/overview",
          name: "overview",
          component: () =>
            import(
              /* webpackChunkName: "Overview" */ "@/components/page/overview/OverView.vue"
            )
        },
        {
          path: "device",
          name: "sever",
          component: () => import("@/components/page/device/Sever.vue")
        },
        {
          path: "device/sever",
          name: "sever",
          component: () => import("@/components/page/device/Sever.vue")
        },
        {
          path: "device/camera",
          name: "camera",
          component: () => import("@/components/page/device/Camera.vue")
        },
        // {
        //   path: "device/camera/screenshot-list",
        //   name: "camera-screenshot-list",
        //   component: () => import("@/components/page/device/camera-screenshot/camera-screenshot-list")
        // },
        {
          path: "device/group",
          name: "group",
          component: () => import("@/components/page/device/Group.vue")
        },
        {
          path: "live",
          name: "live",
          component: () => import("@/components/page/live/Monitor.vue")
        },
        {
          path: "live/monitor",
          name: "live",
          component: () => import("@/components/page/live/Monitor.vue")
        },
        {
          path: "event",
          name: "event",
          component: () => import("@/components/page/event/Record.vue")
        },
        {
          path: "event/:name",
          name: "event",
          component: () => import("@/components/page/event/Record.vue")
        },
        {
          path: "ai",
          name: "ai",
          component: () => import("@/components/page/ai/GeneralSkill.vue")
        },
        {
          path: "data-center",
          name: "data-center",
          component: () => import("@/components/page/device/camera-screenshot/camera-screenshot-list")
        },
        {
          path: "alarm-time",
          name: "alarm-time",
          component: () => import("@/components/page/event/alarm-time")
        },
        {
          path: "structured-libs-list/",
          // 结构化库
          name: "structured-libs-list",
          component: () => import("@/components/page/lib-management/structured-libs-list")
        },
        {
          path: "structured-events-list/:structured_lib_id",
          // 结构化库->库存管理页
          name: "structured-events-list",
          component: () => import("@/components/page/lib-management/structured-events-list")
        },
        {
          path: "ai-plugin",
          name: "ai-plugin",
          component: () => import("@/components/page/ai/plugin/index.vue")
        },
        {
          path: "ai/generalSkill",
          name: "generalSkill",
          component: () => import("@/components/page/ai/GeneralSkill.vue")
        },
        {
          path: "ai/face",
          name: "face",
          component: () => import("@/components/page/ai/Face.vue")
        },
        {
          path: "ai/car",
          name: "car",
          component: () => import("@/components/page/ai/Car.vue")
        },
        {
          path: "ai/generalSkill/:id",
          name: "generalSkill",
          component: () => import("@/components/page/ai/skillDetail.vue")
        },
        // {
        //   path: "doc",
        //   name: 'doc',
        //   component: () => import('@/components/page/doc/doc.vue')
        // },
        {
          path: "push",
          name: "push",
          component: () => import("@/components/page/push/push.vue")
        },
        {
          path: "general_skill_configuration",
          name: "general_skill_configuration",
          component: () =>
            import("@/components/page/skill_config/skill_config.vue")
        },
        // {
        //   path: "statistics",
        //   name: 'statistics',
        //   component: () => import( /* webpackChunkName: "statistics" */ '@/components/page/statistics/Statistics.vue')
        // },
        {
          path: "set",
          name: "set"
        },
        {
          path: "set/generalSetting",
          name: "generalSetting",
          component: () =>
            import(
              /* webpackChunkName: "set" */ "@/components/page/set/GeneralSetting.vue"
            )
        },
        {
          // 模板管理
          path: "template",
          name: "template"
        },
        {
          // 截图管理Table列表页
          path: "template/screenshot-template-list",
          name: "screenshot-template-list",
          component: () =>
            import(
              /* webpackChunkName: "screenshotTemplateList" */ "@/components/page/template-management/template-list.vue"
            )
        },
        {
          // AI模板Table列表页
          path: "template/ai-template-list",
          name: "ai-template-list",
          component: () =>
            import(
              /* webpackChunkName: "AITemplateList" */ "@/components/page/template-management/AI-template-list.vue"
            )
        },
        {
          // AI我的插件列表页
          path: "ai-plugin/custom-plugin-list",
          name: "custom-plugin-list",
          component: () =>
            import(
              /* webpackChunkName: "AITemplateList" */ "@/components/page/ai/plugin/custom-plugin-list.vue"
            )
        },
        {
          // AI公共插件页
          path: "ai-plugin/custom-public-plugin",
          name: "custom-public-plugin",
          component: () =>
            import(
              /* webpackChunkName: "AITemplateList" */ "@/components/page/ai/plugin/custom-public-plugin.vue"
            )
        },
        {
          // AI公共插件管理页
          path: "ai-plugin/custom-public-pluginManage",
          name: "custom-public-pluginManage",
          component: () =>
            import(
              /* webpackChunkName: "AITemplateList" */ "@/components/page/ai/plugin/custom-public-pluginManage.vue"
            )
        },
        {
          // 新增创建AI公共插件管理页
          path: "ai-plugin/create-public-pluginManage/:pluginID?",
          name: "create-public-pluginManage",
          component: () =>
            import(
              /* webpackChunkName: "AITemplateList" */ "@/components/page/ai/plugin/create-public-pluginManage"
            )
        },
        {
          // 新增AI自定义插件列表页
          path: "ai/create-custom-plugin/",
          name: "create-ai-custom-plugin",
          component: () =>
            import(
              /* webpackChunkName: "AITemplateList" */ "@/components/page/ai/plugin/create-ai-custom-plugin"
            )
        },
        {
          // 编辑AI自定义插件列表页
          path: "ai/update-custom-plugin/:pluginID/:isPublic?",
          name: "update-ai-custom-plugin",
          component: () =>
            import(
              /* webpackChunkName: "AITemplateList" */ "@/components/page/ai/plugin/update-ai-custom-plugin"
            )
        },
        {
          // 截图模板管理
          path: "template",
          name: "template"
        },
        {
          // 截图管理Table列表页
          path: "template/screenshot-template-list",
          name: "screenshot-template-list",
          component: () =>
            import(
              /* webpackChunkName: "screenshotTemplateList" */ "@/components/page/template-management/template-list.vue"
            )
        },
        {
          // 新增截图模板
          path: "template/screenshot/add",
          name: "add-screenshot-template",
          component: () =>
            import(
              /* webpackChunkName: "addScreenshotTemplate" */ "@/components/page/template-management/add-screenshot-template.vue"
            )
        },
        {
          // 更新截图模板
          path: "template/screenshot/update/:tid",
          name: "update-screenshot-template",
          component: () =>
            import(
              /* webpackChunkName: "updateScreenshotTemplate" */ "@/components/page/template-management/update-screenshot-template.vue"
            )
        },
        {
          // 更新AI模板
          path: "template/ai/update/:tid",
          name: "update-ai-template",
          component: () =>
            import(
              /* webpackChunkName: "updateScreenshotTemplate" */ "@/components/page/template-management/update-ai-template.vue"
            )
        },
        {
          // 新增AI模板
          path: "template/ai/add",
          name: "add-ai-template",
          component: () =>
            import(
              /* webpackChunkName: "addScreenshotTemplate" */ "@/components/page/template-management/add-ai-template.vue"
            )
        },
        {
          // 更新AI模板
          path: "template/ai/update",
          name: "update-ai-template",
          component: () =>
            import(
              /* webpackChunkName: "addScreenshotTemplate" */ "@/components/page/template-management/update-ai-template.vue"
            )
        },
        {
          // 查看AI模板
          path: "template/ai/detail/:tid",
          name: "view-ai-template",
          component: () =>
            import(
              /* webpackChunkName: "addScreenshotTemplate" */ "@/components/page/template-management/view-ai-template.vue"
            )
        },
        // {
        //   // 更新AI模板
        //   path: "template/ai/update/:tid",
        //   name: "update-ai-template",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "updateScreenshotTemplate" */ "@/components/page/template-management/update-ai-template.vue"
        //     )
        // },
        {
          path: "set/currentConfig",
          name: "currentConfig",
          component: () =>
            import(
              /* webpackChunkName: "currentConfig" */ "@/components/page/set/CurrentConfig.vue"
            )
        },
        {
          path: "set/haikangConfig",
          name: "haikangConfig",
          component: () =>
            import(
              /* webpackChunkName: "haikangConfig" */ "@/components/page/set/haikangConfig.vue"
            )
        },
        {
          path: "message",
          name: "message",
          component: () =>
            import(
              /* webpackChunkName: "message" */ "@/components/page/message/Message.vue"
            )
        },
        {
          path: "messageDetails",
          name: "messageDetails",
          component: () =>
            import(
              /* webpackChunkName: "messageDetails" */ "@/components/page/message/MessageDetails.vue"
            )
        },
        {
          path: "ai/skill_admin/model/index",
          name: "model",
          component: () =>
            import(
              /* webpackChunkName: "messageDetails" */ "@/components/page/ai/skill_admin/model/index.vue"
            )
        },
        {
          path: "ai/skill_admin/plugin/index",
          name: "plugin",
          component: () =>
            import(
              /* webpackChunkName: "messageDetails" */ "@/components/page/ai/skill_admin/plugin/index.vue"
            )
        },
        {
          path: "ai/skill_admin/sku/index",
          name: "sku",
          component: () =>
            import(
              /* webpackChunkName: "messageDetails" */ "@/components/page/ai/skill_admin/sku/index.vue"
            )
        },
        {
          path: "ai/skill_admin/support/index",
          name: "support",
          component: () =>
            import(
              /* webpackChunkName: "messageDetails" */ "@/components/page/ai/skill_admin/support/index.vue"
            )
        },
        // 向量库
        {
          path: 'lib-management/vector-lib',
          name: 'vector-lib',
          component: () =>
            import(
              /* webpackChunkName: "libManagement" */ "@/components/page/lib-management/VectorLib.vue"
            )
        },
        // ID库
        {
          path: 'lib-management/id-lib',
          name: 'id-lib',
          component: () =>
            import(
              /* webpackChunkName: "IDLibManagement" */ "@/components/page/id-libs/IDLibs.vue"
            )
        },
        // ID库-库存管理
        {
          path: 'lib-management/id-lib-stock-list/:id_lib_id',
          name: 'id-lib-stock-list',
          component: () =>
            import(
              /* webpackChunkName: "IDLibStockList" */ "@/components/page/id-libs/IDLibStockList.vue"
            )
        }
      ]
    },
    {
      path: "/guide",
      name: "guide",
      component: guide
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js